export enum PaymentCategoryEnum {
  DEFAULT = 'DEFAULT',
  FIDELITY = 'FIDELITY',
  PREMIUM = 'PREMIUM',
}

export enum PaymentMethodEnum {
  BANK_SLIP = 'BANK_SLIP',
  CASH = 'CASH',
  CHECK = 'CHECK',
  DEPOSIT = 'DEPOSIT',
}

export const PaymentMethodMapping = {
  [PaymentMethodEnum.BANK_SLIP]: 'Boleto',
  [PaymentMethodEnum.CASH]: 'Dinheiro',
  [PaymentMethodEnum.CHECK]: 'Cheque',
  [PaymentMethodEnum.DEPOSIT]: 'Depósito',
};

export const PaymentCategoryMapping = {
  [PaymentCategoryEnum.DEFAULT]: 'Padrão',
  [PaymentCategoryEnum.FIDELITY]: 'Fidelidade',
  [PaymentCategoryEnum.PREMIUM]: 'Premium',
};
